
























































































import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';
import { Action, namespace } from 'vuex-class';
import { ActionError as campaignStoreErr } from '@/store/campaign/types';
import moment from 'moment';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SetCampaign as feedbackTerms} from '@/const/terms/feedback/campaign';
import { SettingConfirm as confirmTerms} from '@/const/terms/feedback/confirm';

import { STATUS } from '@/const/status/index';
import {
    DefaultOption,
    TableOptionType,
} from '@/const/options/DefaultTableOption';
import { IAPP, ID_TYPE, DATE_TYPE } from '@/const/types';
import {
    CampaignDataType,
    ISearchForm,
    ICampaignData,
    CampaignResponse,
} from './types';

import { RawLocation } from 'vue-router';
import { TableColumn } from 'element-ui/types/table-column';
import { AxiosError, AxiosResponse } from 'axios';

import DateRangePicker from '@/components/ElementComponent/Date/DateRangePicker.vue';
import Select from '@/components/ElementComponent/Select/index.vue';
import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import ExplainColumn from '@/components/ElementComponent/Column/ExplainColumn.vue';
import NameColumn from '@/components/ElementComponent/Column/NameColumn.vue';
import NumberInput from '@/components/ElementComponent/Input/NumberInput.vue';

import {Table as ElTable} from "element-ui/types/element-ui";
import DateTimeFormat = Intl.DateTimeFormat;

const campaignModule = namespace('Campaign');

@Component<Campaign>({
    name: 'Campaign',
    components: {
        DateRangePicker,
        Select,
        NumberColumn,
        DateColumn,
        StatusColumn,
        SelectAllColumn,
        ExplainColumn,
        NameColumn,
        NumberInput,
    },
})
export default class Campaign extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;
    private confirmTerms = confirmTerms;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private deleteConfirmVisible: boolean = false;

    private dateValue: DATE_TYPE[] = [new Date(), new Date()];
    private filterForm: ISearchForm = { status: STATUS.ACTIVE, apps: [], query: '', page: 1, totalPages: 0, sort: null};
    private statusOptions: { value: STATUS; label: string; }[] = [
        { value: STATUS.ALL, label: '모든 상태'},
        { value: STATUS.ACTIVE, label: '활성' },
        { value: STATUS.INACTIVE, label: '비활성' },
    ];
    private appOptions: SelectOptionType<IAPP>[] = [];
    private tableData: CampaignDataType = [];
    private selectedCampaign: CampaignDataType = [];

    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign: any;

    get date() {
        return [
            moment(this.dateValue[0]).format('YYYYMMDDHH'),
            moment(this.dateValue[1]).format('YYYYMMDDHH'),
        ];
    }
    private setSelectedCampaign(val: CampaignDataType) {
        this.selectedCampaign = val;
    }
    private async setCurrentCampaignHandler(scope: any, to: RawLocation, isCtrlPressed: boolean) {
        try {
            const app = this.appOptions.find((v: SelectOptionType<IAPP>) => (v.value as IAPP).key.toString() === scope.row.appKey.toString()) as SelectOptionType<IAPP>;
            await this.setCurrentCampaign({
                id: scope.row.id,
                name: scope.row.name,
                app: app ? app.value : null,
            });
            if (isCtrlPressed) {
                const routerData = this.$router.resolve(to);
                window.open(routerData.href, '_blank');
            } else {
                this.$router.push(to);
            }
        } catch (err) {
            switch (err.type) {
                case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                    this.$notify.error(feedbackTerms.currentCampaign.error.fail);
                    break;
            }
            throw err;
        }
    }

    private appKeyMatchFormatter(row: any, column: TableColumn) {
        if (this.tableData.length === 0 && this.appOptions.length === 0) {
            return '확인 중...';
        }
        const app = this.appOptions.find((v: SelectOptionType<IAPP>) => (v.value as IAPP).key.toString() === row[column.property].toString())
        if (app && app.label) {
            return app.label;
        }
        return '알 수 없음';
    }
    private copyCampaigns(campaign: ICampaignData) {
        this.loading = true;
        this.$http.adserverAPI.post('CopyCampaign', {
            campaign_id: campaign.id,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.copyCampaign.success);
                    this.getCampaignResponseHandler();
                    return ;
                }
                throw new Error(feedbackTerms.copyCampaign.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.copyCampaign.error.fail)
                } else {
                    this.$notify.error(err.message);
                }
                this.loading = false
                throw err;
            })
    }
    private deleteCampaigns() {
        this.deleteConfirmVisible = false;
        const targetIDs = this.selectedCampaign.map((item: ICampaignData) => {
            return item.id;
        })
        if (targetIDs.length === 0) return true;
        this.loading = true;
        this.$http.adserverAPI.post('DeleteCampaign', {
            campaign_ids: targetIDs,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.deleteCampaign.success);
                    this.getCampaignResponseHandler();
                    return true;
                }
                throw new Error(feedbackTerms.deleteCampaign.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.deleteCampaign.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                this.loading = false;
                throw err;
            })
    }
    private changeStatus(campaigns: ICampaignData[], is_use: boolean | null = null, fromTools: boolean = false) {
        if (campaigns.length === 0) return false;
        const campaign_ids = campaigns.map((item: ICampaignData) => item.id);
        let toStatus: boolean = ((campaigns[0].status as STATUS) & 1) === (fromTools ?  STATUS.ACTIVE : STATUS.INACTIVE);
        if (is_use !== null) toStatus = is_use;
        let statusBackup: STATUS[] = [];

        campaigns.forEach((item: ICampaignData) => {
            const s = item.status as STATUS;
            if (fromTools) statusBackup.push(s);
            else statusBackup.push(((s & ~1) | ((s & 1) ^ 1)));
            item.status = (s & ~1) | (toStatus? STATUS.ACTIVE : STATUS.INACTIVE);
            this.$nextTick(() => {
                item.disabled = true;
            });
        })
        
        statusBackup = statusBackup.reverse();
        this.$http.adserverAPI.post('UpdateCampaignStatus', {
            campaign_ids: campaign_ids,
            is_use: toStatus,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.changeStatus.success);
                    return true;                
                }
                throw new Error(feedbackTerms.changeStatus.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.changeStatus.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                campaigns.forEach((item: ICampaignData) => {
                    const s = statusBackup.pop() as STATUS;
                    item.status = s;
                })
                throw err;
            })
            .finally(() => {
                this.loading = false;
                campaigns.forEach((item: ICampaignData) => {
                    item.disabled = false;
                })
            })
    }
    private saveWeight() {
        this.submit().then((res: any) => res.data)
            .then((data: {result: boolean}) =>{
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.saveWeight.success)
                    return;
                }
                throw new Error(feedbackTerms.saveWeight.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.saveWeight.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
    }
    private submit() {
        const reqData = this.tableData.map((item: ICampaignData) => ({
                id: item.id,
                weight: item.impWeight ? item.impWeight : 0,
            })
        );
        return this.$http.adserverAPI.post('UpdateCampaignWeight', {
            campaigns: reqData,
        })
    }
    // private submit() {
    //     return Promise.resolve(JSON.parse(JSON.stringify({status: 200, data: {result: true}})));
    // }

    private getReportUpdateDateTime() {
      this.$http.adserverAPI.post('GetReportUpdateTime').then((res: any) => res.data)
          .then((data: any) => {
            const reportUpdateTime = this.$refs.reportUpdateTime as HTMLParagraphElement;
            reportUpdateTime.innerText = '* 리포트는 5분마다 자동으로 갱신됩니다(' + data.update_datetime + ')'
          })
          .catch((err: AxiosError) => {
          })
    }

    private refreshDate(v: Date[]) {
        if (v) {
            this.getCampaignResponseHandler();
        }
    }

    private sortChangeHandler({ column, prop, order }: {column: any, prop: string, order: string}) {
        this.filterForm.sort = prop ? {prop: prop, order: order} : null;
        this.getCampaignResponseHandler();
    }
    private getCampaignResponseHandler() {
        this.loading = true;
        this.selectedCampaign = [];
        this.getCampaignResponse().then( (res: any) => res.data)
            .then((data: CampaignResponse) => {
                this.tableData = data.campaigns;
                this.filterForm.totalPages = data.pages;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {            
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
            })
    }

    private getCampaignResponse(){
        this.setRouteQueryFromFilter();
        const sort = this.filterForm.sort && this.filterForm.sort.prop ? `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}` : '';
        return this.$http.adserverAPI.post('GetCampaignReport', {
            since: this.date[0],
            until: this.date[1],
            status: this.filterForm.status,
            app: this.filterForm.apps.map((item: IAPP) => item.key),
            query: this.filterForm.query,
            page_no: this.filterForm.page,
            sort: sort,
        }) 
    }

    private setRouteQueryFromFilter(){
        const query: {[name: string]: any} = {
            since: (this.dateValue[0] as Date).getTime(),
            until: (this.dateValue[1] as Date).getTime(),
        }
        this.filterForm.apps && (query.apps = JSON.stringify(this.filterForm.apps));
        this.filterForm.status !== undefined && (query.status = this.filterForm.status);
        this.filterForm.query && (query.query = this.filterForm.query);
        this.filterForm.page && (query.page = this.filterForm.page);
        this.filterForm.sort && this.filterForm.sort.prop && this.filterForm.sort.order && (query.sort = `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}`);

        const newQuery = Object.entries(query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: encodeURIComponent(value)};
        }, {});
        
        if (!(_.isEqual(newQuery, this.$route.query))) {
            this.$router.replace({
                ...this.$route,
                query: newQuery,
            })
        }
    }
    private setRouteQueryToFilter() {
        const query = Object.entries(this.$route.query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: decodeURIComponent(value)};
        }, {}) as any;
        query.since !== undefined && (this.dateValue[0] = new Date(Number.parseInt(query.since as string)));
        query.until !== undefined && (this.dateValue[1] = new Date(Number.parseInt(query.until as string)));
        this.dateValue = [this.dateValue[0], this.dateValue[1]];
        
        query.apps !== undefined && (this.filterForm.apps = JSON.parse(query.apps as string));
        query.status !== undefined && (this.filterForm.status = Number.parseInt(query.status as string) as STATUS);
        query.query !== undefined && (this.filterForm.query = query.query as string);
        query.page !== undefined && (this.filterForm.page = Number.parseInt((query.page as string)));
        query.sort !== undefined && (this.filterForm.sort = (query.sort as string)[0] === '-' ? { 
            order: 'descending', prop: (query.sort as string).slice(1)
        } : {
            order: 'ascending', prop: (query.sort as string)
        });
    }
    private created() {
        this.setRouteQueryToFilter();
        this.$http.adserverAPI.post('GetSSPAppList', {inventory: false}).then((res: any) => res.data)
                .then((data: IAPP[]) => {
                    this.appOptions = data.map((item: IAPP) => {
                        return {
                            label: item.name,
                            value: item,
                        } as SelectOptionType<IAPP>;
                    })
                        .sort((a: SelectOptionType<IAPP>, b: SelectOptionType<IAPP>) => a.label < b.label ? -1 : 1);
                })
      this.getReportUpdateDateTime();
    }
    private mounted() {
        this.$nextTick( () => {
            this.getCampaignResponseHandler(); 
        })
    }
}


